import AxiosWrapper from "@/helpers/axios-wrapper";

/**
* @returns Promise
 */
export function getConstantsData() {
    const params = {};
    return AxiosWrapper('/get_constants_data/', {params});
}
